import type { Calendar } from 'commoncal-shared';

export function useJoinUrl(
  calendar:
    | Pick<Calendar, 'id' | 'join_token' | 'is_personal'>
    | null
    | undefined
): string | null {
  if (
    !calendar ||
    calendar.is_personal ||
    !calendar.join_token
  )
    return null;
  return `${window.location.origin}/calendar/${calendar.id}?join_token=${calendar.join_token}`;
}
